import styled from '@emotion/styled';

export const RoutingSVG = ({ height, width, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '20'}
    height={height || '24.444'}
    viewBox="0 0 20 24.444"
  >
    <path
      data-name="Path 2306"
      d="M13 1A10 10 0 0 0 3 11v7.778a3.329 3.329 0 0 0 3.333 3.333h3.334v-8.889H5.222V11a7.778 7.778 0 0 1 15.556 0v2.222h-4.445v8.889h4.444v1.111H13v2.222h6.667A3.329 3.329 0 0 0 23 22.111V11A10 10 0 0 0 13 1z"
      transform="translate(-3 -1)"
      fill={color || '#ffffff'}
    />
  </svg>
);

export const PlusIcon = ({ height, width, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '42.32'}
    height={height || '42.32'}
    viewBox="0 0 42.32 42.32"
  >
    <path
      data-name="Icon ionic-ios-add"
      d="M48.65 27.49H32.76V11.6a2.635 2.635 0 1 0-5.269 0v15.89H11.6a2.635 2.635 0 0 0 0 5.269h15.89V48.65a2.635 2.635 0 1 0 5.269 0V32.76H48.65a2.635 2.635 0 1 0 0-5.269z"
      transform="translate(-8.965 -8.965)"
      fill={color || '#196cca'}
    />
  </svg>
);

export const PlusGreenIcon = (props) => (
  <svg
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      data-name="Icon ionic-ios-add-circle"
      d="M13.375 3.375a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm4.351 10.769h-3.582v3.582a.769.769 0 0 1-1.538 0v-3.582H9.024a.769.769 0 1 1 0-1.538h3.582V9.024a.769.769 0 1 1 1.538 0v3.582h3.582a.769.769 0 1 1 0 1.538z"
      transform="translate(-3.375 -3.375)"
      fill="#07aa3f"
    />
  </svg>
);

export const MinusRedIcon = (props) => (
  <svg
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      data-name="Icon ionic-ios-remove-circle"
      d="M13.375 3.375a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm4.351 10.769h-8.7a.745.745 0 0 1-.769-.769.737.737 0 0 1 .769-.769h8.7a.769.769 0 0 1 0 1.538z"
      transform="translate(-3.375 -3.375)"
      fill="#ee3048"
    />
  </svg>
);

export const DraggableIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#ee3048"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
  </svg>
);

const MoreMenuIcon = (props) => (
  <div className={`${props.className}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="3.125"
      height="12.5"
      viewBox="0 0 3.125 12.5"
    >
      <path
        data-name="Icon ionic-md-more"
        d="M18.313 8.313a1.563 1.563 0 1 0-1.563 1.562 1.567 1.567 0 0 0 1.563-1.562zm0 9.375a1.563 1.563 0 1 0-1.563 1.562 1.567 1.567 0 0 0 1.563-1.562zm0-4.687a1.563 1.563 0 1 0-1.562 1.562A1.567 1.567 0 0 0 18.313 13z"
        transform="translate(-15.188 -6.75)"
      />
    </svg>
  </div>
);

export default styled(MoreMenuIcon)`
  svg {
    path {
      fill: ${(props) => props.theme.colors.topBarAccTextColor};
    }
  }
`;

export const GroupDeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6.222"
    height="8"
    viewBox="0 0 6.222 8"
  >
    <path
      data-name="Icon material-delete"
      d="M7.944 11.611a.892.892 0 0 0 .889.889h3.556a.892.892 0 0 0 .889-.889V6.278H7.944zm5.778-6.667h-1.555l-.445-.444H9.5l-.444.444H7.5v.889h6.222z"
      transform="translate(-7.5 -4.5)"
      fill="#ee3048"
    />
  </svg>
);

export const EditGroupIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
  >
    <path
      data-name="Icon material-edit"
      d="M4.5 10.83v1.67h1.666l4.915-4.915-1.666-1.67zm7.87-4.537a.443.443 0 0 0 0-.627l-1.04-1.04a.443.443 0 0 0-.627 0l-.813.813 1.666 1.666z"
      transform="translate(-4.5 -4.496)"
      fill="#777"
    />
  </svg>
);

export const OutgoingCallIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="19.243"
    height="19.243"
    viewBox="0 0 19.243 19.243"
  >
    <g data-name="Icon feather-arrow-up-right">
      <path
        data-name="Path 2322"
        d="m10.5 25.5 15-15"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '3px',
        }}
        transform="translate(-8.379 -8.379)"
      />
      <path
        data-name="Path 2323"
        d="M10.5 10.5h15v15"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '3px',
        }}
        transform="translate(-8.379 -8.379)"
      />
    </g>
  </svg>
);

export const CallIcon = ({ className, style }) => (
  <svg
    className={className}
    fill="currentColor"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="55.999"
    height="55.999"
    viewBox="0 0 55.999 55.999"
  >
    <path
      data-name="Icon ionic-ios-call"
      d="M58.872 48.351a47.035 47.035 0 0 0-9.826-6.575c-2.945-1.414-4.023-1.385-6.108.117-1.735 1.254-2.857 2.42-4.854 1.983s-5.933-3.412-9.753-7.217-6.793-7.756-7.216-9.753.743-3.12 1.983-4.855c1.5-2.085 1.545-3.164.117-6.109a46.11 46.11 0 0 0-6.575-9.826c-2.143-2.143-2.624-1.677-3.8-1.254a21.65 21.65 0 0 0-3.489 1.851 10.511 10.511 0 0 0-4.184 4.417c-.831 1.793-1.793 5.132 3.105 13.85A77.282 77.282 0 0 0 21.858 43.1l.015.015.015.015a77.578 77.578 0 0 0 18.12 13.59c8.718 4.9 12.056 3.936 13.849 3.105a10.331 10.331 0 0 0 4.417-4.184 21.653 21.653 0 0 0 1.851-3.484c.423-1.182.904-1.663-1.253-3.806z"
      transform="translate(-4.49 -4.502)"
      style={{ fill: 'inherit' }}
    />
  </svg>
);

export const DarkModeOffIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    onClick={props.onClick}
    width="36"
    height="24"
    viewBox="0 0 36 24"
  >
    <path
      data-name="Icon awesome-toggle-on"
      d="M24 4.5H12a12 12 0 0 0 0 24h12a12 12 0 0 0 0-24zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      transform="rotate(-180 18 14.25)"
      fill="#939598"
    />
  </svg>
);

export const DarkModeOnIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    onClick={props.onClick}
    width="36"
    height="24"
    viewBox="0 0 36 24"
  >
    <path
      data-name="Icon awesome-toggle-on"
      d="M24 4.5H12a12 12 0 0 0 0 24h12a12 12 0 0 0 0-24zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      transform="translate(0 -4.5)"
      fill={props.fill || '#fff'}
    />
  </svg>
);

export const EditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    onClick={props.onClick}
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g transform="translate(-1808 -216)">
      <rect
        width="32"
        height="32"
        fill="#196cca"
        rx="3"
        transform="translate(1808 216)"
      />
      <path
        fill="#fff"
        d="M4.5 17.166V20.5h3.334l9.832-9.832-3.334-3.334zM20.244 8.09a.885.885 0 0 0 0-1.253l-2.08-2.08a.885.885 0 0 0-1.253 0l-1.628 1.626 3.334 3.334 1.627-1.627z"
        transform="translate(1811.5 219.504)"
      />
    </g>
  </svg>
);

export const MusicIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46.169"
    height="60"
    viewBox="0 0 46.169 60"
  >
    <path
      data-name="Icon ionic-ios-musical-notes"
      d="M51.505 3.4c-.678.13-29.135 5.654-29.741 5.769a1.279 1.279 0 0 0-1.164 1.158v34.63a3.978 3.978 0 0 1-.346 1.688 3.843 3.843 0 0 1-2.322 1.832c-.476.159-1.125.3-1.889.476-3.476.779-9.289 2.106-9.289 7.471a6.6 6.6 0 0 0 6.014 6.851 7.032 7.032 0 0 0 1.024.1c.966 0 5.192-.476 7.385-1.9a7.771 7.771 0 0 0 3.476-6.894V23.928a1.145 1.145 0 0 1 .923-1.125L47.5 18.375a1.153 1.153 0 0 1 1.38 1.125v18.88a4.135 4.135 0 0 1-.361 1.933 3.833 3.833 0 0 1-2.337 1.832c-.476.159-1.269.3-2.034.476-3.476.779-9.289 2.091-9.289 7.457a6.615 6.615 0 0 0 6.029 6.966 11.92 11.92 0 0 0 2.8-.13 16.536 16.536 0 0 0 5.264-1.875 7.6 7.6 0 0 0 3.966-6.952V4.514A1.143 1.143 0 0 0 51.505 3.4z"
      transform="translate(-6.75 -3.375)"
      fill="#196cca"
    />
  </svg>
);

export const SmallMusicIcon = ({ color, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '15.39'}
    height={height ? height : '20'}
    viewBox="0 0 15.39 20"
  >
    <path
      data-name="Icon ionic-ios-musical-notes"
      d="m21.668 3.385-9.913 1.923a.426.426 0 0 0-.389.385v11.543a1.326 1.326 0 0 1-.115.563 1.281 1.281 0 0 1-.774.611c-.159.053-.375.1-.63.159-1.159.26-3.1.7-3.1 2.49a2.2 2.2 0 0 0 2 2.284 2.344 2.344 0 0 0 .341.034 5.934 5.934 0 0 0 2.462-.635 2.59 2.59 0 0 0 1.159-2.3V10.226a.382.382 0 0 1 .308-.375l7.308-1.476a.384.384 0 0 1 .462.375v6.293a1.378 1.378 0 0 1-.12.644 1.278 1.278 0 0 1-.779.611c-.159.053-.423.1-.678.159-1.159.26-3.1.7-3.1 2.486a2.2 2.2 0 0 0 2.01 2.322 3.973 3.973 0 0 0 .933-.043 5.512 5.512 0 0 0 1.755-.625 2.534 2.534 0 0 0 1.322-2.317V3.755a.381.381 0 0 0-.462-.37z"
      transform="translate(-6.75 -3.375)"
      fill={color ? color : '#fff'}
    />
  </svg>
);

export const PlayCallerTuneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14.999"
    viewBox="0 0 12 14.999"
  >
    <path
      data-name="Icon ionic-ios-play"
      d="M9 7.139V21.36a.366.366 0 0 0 .548.337l11.272-7.11a.4.4 0 0 0 0-.67L9.548 6.807A.363.363 0 0 0 9 7.139z"
      transform="translate(-9 -6.751)"
      fill="#fff"
    />
  </svg>
);

export const AccessTimeIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className={className}
  >
    <path
      data-name="Icon material-access-time"
      d="M10.992 3A8 8 0 1 0 19 11a8 8 0 0 0-8.008-8zM11 17.4a6.4 6.4 0 1 1 6.4-6.4 6.4 6.4 0 0 1-6.4 6.4zM11.4 7h-1.2v4.8l4.2 2.52.6-.984-3.6-2.136z"
      transform="translate(-3 -3)"
      fill="#196cca"
    />
  </svg>
);

export const CommentIcon = (props) => {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    onClick={props.onClick}
    width="24px"
    fill="#000000"
  >
    <g transform="translate(-1808 -216)">
      <rect
        width="32"
        height="32"
        fill="#196cca"
        rx="3"
        transform="translate(1808 216)"
      />
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
    </g>
  </svg>;
};

export const CheckboxChecked = (props) => {
  return (
    <svg
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        data-name="Icon ionic-ios-checkbox"
        d="M19.167 4.5H5.833A1.332 1.332 0 0 0 4.5 5.833v13.334A1.332 1.332 0 0 0 5.833 20.5h13.334a1.332 1.332 0 0 0 1.333-1.333V5.833A1.332 1.332 0 0 0 19.167 4.5zm-2.188 5.6-5.571 5.6a.752.752 0 0 1-.483.229.729.729 0 0 1-.488-.237L8.1 13.358a.166.166 0 0 1 0-.238l.742-.742a.161.161 0 0 1 .233 0l1.85 1.85 5.083-5.121a.165.165 0 0 1 .117-.05.151.151 0 0 1 .117.05l.729.754a.164.164 0 0 1 .008.239z"
        transform="translate(-4.5 -4.5)"
        style={{ fill: '#282828', cursor: 'pointer' }}
      />
    </svg>
  );
};

export const CheckboxIntermediate = (props) => {
  return (
    <svg
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        d="M122.889-831.378h10.244v-1.333h-10.244zM121.333-824a1.279 1.279 0 0 1-.933-.4 1.279 1.279 0 0 1-.4-.933v-13.333a1.279 1.279 0 0 1 .4-.933 1.279 1.279 0 0 1 .933-.4h13.333a1.279 1.279 0 0 1 .933.4 1.279 1.279 0 0 1 .4.933v13.333a1.279 1.279 0 0 1-.4.933 1.279 1.279 0 0 1-.933.4z"
        transform="translate(-120 840)"
        style={{ fill: '#282828', cursor: 'pointer' }}
      />
    </svg>
  );
};

export const HorizontalDotsIcon = (props) => {
  return (
    <div
      style={{
        width: '32px',
        height: '32px',
        borderRadius: '3px',
        backgroundColor: props.type === "campaigns" ? "#196cca" :'#eaeaea',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      onClick={props.onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="4"
        viewBox="0 0 16 4"
      >
        <path
          data-name="Icon material-more-horiz"
          d="M8 15a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm12 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm-6 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2z"
          transform="translate(-6 -15)"
        />
      </svg>
    </div>
  );
};

export const CheckboxUnchecked = (props) => {
  return (
    <svg
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        data-name="Icon material-check-box-outline-blank"
        d="M18.722 6.278v12.444H6.278V6.278h12.444m0-1.778H6.278A1.783 1.783 0 0 0 4.5 6.278v12.444A1.783 1.783 0 0 0 6.278 20.5h12.444a1.783 1.783 0 0 0 1.778-1.778V6.278A1.783 1.783 0 0 0 18.722 4.5z"
        transform="translate(-4.5 -4.5)"
        style={{
          fill: '#d2d3d4',
          cursor: 'pointer',
        }}
      />
    </svg>
  );
};

export const ReportIcon = (props) => {
  return (
    <div
      style={{
        width: '32px',
        height: '32px',
        borderRadius: '3px',
        backgroundColor: '#eaeaea',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      onClick={props.onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.667"
        height="16"
        viewBox="0 0 18.667 16"
      >
        <path
          data-name="Icon material-history"
          d="M10.667 0a8 8 0 0 0-8 8H0l3.458 3.458.062.124L7.111 8H4.444a6.252 6.252 0 1 1 1.831 4.391l-1.262 1.262A8 8 0 1 0 10.667 0zm-.889 4.444v4.444l3.8 2.258.64-1.076-3.111-1.849V4.444z"
        />
      </svg>
    </div>
  );
};

export const VoiceBroadcastIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
    >
      <path
        d="M96.25-791.25v-1.5H100v1.5zM97.5-784l-3.025-2.25.9-1.2 3.025 2.25zm-2.05-12.575-.9-1.2L97.5-800l.9 1.2zM83.25-785v-4H81.5a1.447 1.447 0 0 1-1.062-.437A1.447 1.447 0 0 1 80-790.5v-3a1.446 1.446 0 0 1 .438-1.062A1.446 1.446 0 0 1 81.5-795H86l5-3v12l-5-3h-1.25v4zm8.75-3.65v-6.7a4.567 4.567 0 0 1 1.088 1.463A4.318 4.318 0 0 1 93.5-792a4.318 4.318 0 0 1-.412 1.888A4.567 4.567 0 0 1 92-788.65z"
        transform="translate(-80 800)"
        style={{ fill: '#fff' }}
      />
    </svg>
  );
};

export const MessageBroadcastIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.669"
      height="20"
      viewBox="0 0 23.669 20"
    >
      <path
        d="m99.349-820-1.243-1.243 2.16-2.189h-5.355v-1.775h5.355l-2.16-2.189 1.243-1.243 4.32 4.32zm-9.408-10.888 8.4-5.3v-2.041l-8.4 5.148-8.166-5.148v2.189zm-8.166 7.456a1.71 1.71 0 0 1-1.254-.521 1.71 1.71 0 0 1-.521-1.254v-13.018a1.71 1.71 0 0 1 .521-1.254 1.71 1.71 0 0 1 1.254-.521h16.568a1.71 1.71 0 0 1 1.254.521 1.71 1.71 0 0 1 .521 1.254v6.864q-.222-.03-.444-.044t-.444-.015a6.965 6.965 0 0 0-5.074 1.982 6.736 6.736 0 0 0-2.027 5.03q0 .247.015.493a2.641 2.641 0 0 0 .074.483z"
        transform="translate(-80 840)"
        style={{ fill: '#fff' }}
      />
    </svg>
  );
};

export const PaymentSuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="340"
      height="340"
      viewBox="0 0 340 340"
    >
      <defs>
        <pattern
          id="3o7it6egna"
          preserveAspectRatio="none"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
        >
          <image
            width="512"
            height="512"
            xlinkHref="data:image/png;base64,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"
          />
        </pattern>
      </defs>
      <path
        data-name="Animation - 1702883524592"
        style={{ fill: 'url(#3o7it6egna)' }}
        d="M0 0h340v340H0z"
      />
    </svg>
  );
};

export const AlertIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43.338"
      height="40"
      viewBox="0 0 43.338 40"
    >
      <path
        data-name="Icon ion-ios-warning"
        d="M22.219 6.156 3.771 39.823A3.166 3.166 0 0 0 6.594 44.5H43.5a3.173 3.173 0 0 0 2.823-4.677L27.865 6.156a3.234 3.234 0 0 0-5.646 0zm4.656 13.969L26.5 32.833h-2.917l-.375-12.708zM25.042 39.75a1.918 1.918 0 1 1 1.99-1.917 1.935 1.935 0 0 1-1.99 1.917z"
        transform="translate(-3.375 -4.5)"
        style={{ fill: '#ed3833' }}
      />
    </svg>
  );
};

export const LockCloseIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
    >
      <defs>
        <filter
          id="i4di7gq1ga"
          x="26"
          y="24"
          width="48.476"
          height="58"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity=".161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 3237" transform="translate(-910 -362)">
        <circle
          data-name="Ellipse 764"
          cx="50"
          cy="50"
          r="50"
          transform="translate(910 362)"
          style={{ fill: '#f07037' }}
        />
        <g style={{ filter: 'url(#i4di7gq1ga)' }}>
          <path
            data-name="lock_FILL1_wght400_GRAD0_opsz24"
            d="M163.81-880a3.668 3.668 0 0 1-2.69-1.119 3.669 3.669 0 0 1-1.119-2.69v-19.048a3.668 3.668 0 0 1 1.119-2.69 3.668 3.668 0 0 1 2.69-1.119h1.9v-3.809a9.178 9.178 0 0 1 2.786-6.738 9.178 9.178 0 0 1 6.742-2.787 9.178 9.178 0 0 1 6.738 2.786 9.178 9.178 0 0 1 2.786 6.738v3.809h1.9a3.668 3.668 0 0 1 2.69 1.119 3.668 3.668 0 0 1 1.119 2.69v19.048a3.669 3.669 0 0 1-1.119 2.69 3.669 3.669 0 0 1-2.69 1.119zm11.429-9.524a3.668 3.668 0 0 0 2.69-1.119 3.668 3.668 0 0 0 1.119-2.69 3.668 3.668 0 0 0-1.119-2.69 3.668 3.668 0 0 0-2.69-1.119 3.668 3.668 0 0 0-2.69 1.119 3.668 3.668 0 0 0-1.119 2.69 3.668 3.668 0 0 0 1.119 2.69 3.668 3.668 0 0 0 2.689 1.119zm-5.714-17.143h11.429v-3.809a5.511 5.511 0 0 0-1.667-4.048 5.51 5.51 0 0 0-4.048-1.667 5.51 5.51 0 0 0-4.048 1.667 5.511 5.511 0 0 0-1.667 4.048z"
            transform="translate(785 1312)"
            style={{ fill: '#fff' }}
          />
        </g>
      </g>
    </svg>
  );
};
